import { Breadcrumbs } from "../../../AbstractElements";
import { CkEditor, Editors } from "../../../Constant";
import { Container, Row } from "reactstrap";
import Editor from "./Editor/Editor";
import InlineEditor from "./InlineEditor";

const CkEditorsContainer = () => {
  return (
    <>
      <Breadcrumbs pageTitle={CkEditor} parent={Editors} title={CkEditor} />
      <Container fluid>
        <Row>
          <Editor />
          <InlineEditor />
        </Row>
      </Container>
    </>
  );
};

export default CkEditorsContainer;
